/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createClassicalElectronRadius } from '../../factoriesAny.js';
export var classicalElectronRadiusDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createClassicalElectronRadius: createClassicalElectronRadius
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesClassicalElectronRadius.generated.js
// module id = 1502
// module chunks = 0